import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import {
  provideRouter,
  withComponentInputBinding,
  withHashLocation,
} from '@angular/router';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalInterceptorConfiguration,
  MsalService,
} from '@azure/msal-angular';
import {
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

import { environment } from '../environments/environment';
import { AuthInterceptor } from '../shared/interceptors/auth.interceptor';
import { routes } from './app.routes';

const _apiUrl = environment.apiUrl;
const _clientIdAzure = environment.azure.clientId;
const _authorityAzure = `https://login.microsoftonline.com/${environment.azure.tenantId}`;
const _redirectAplicationAzure = environment.azure.redirectUri;
const _scopesAzure = environment.azure.scopes;

/**
 * Crea la instancia de PublicClientApplication para MSAL.
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: _clientIdAzure,
      authority: _authorityAzure,
      redirectUri: _redirectAplicationAzure,
    },
  });
}

/**
 * Configura el interceptor para MSAL.
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(_apiUrl, _scopesAzure);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: {
      extraScopesToConsent: _scopesAzure,
    },
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation(), withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(BrowserAnimationsModule),
    { provide: LOCALE_ID, useValue: 'es-MX' },
    provideAnimations(),
    MsalService,
    MsalBroadcastService,
    /**
     * Se provee la instancia de MSAL creada por la MSALInstanceFactory
     */
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },

    /**
     * Se provee la configuración para el interceptor de MSAL
     */
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },

    /**
     * Provisión del interceptor MSAL a la aplicación.
     * 'multi: true' indica que pueden existir múltiples interceptores.
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
};
